import { XIcon } from '@heroicons/react/outline'
import { useTw } from '../../../../../../../../../utils/Styles'
import { ConversationQuery } from '../../../../Conversation.generated'
import { useRemoveUnfUrlCardMutation } from './RemoveUnfURLCard.generated'
import { ConversationSenderType } from '../../../../../../../../../api/types'

type Props = {
  event: ConversationQuery['Conversation']['messages'][0]
}

function RemoveCard({ event }: Props) {
  const tw = useTw()
  const [mutate] = useRemoveUnfUrlCardMutation()

  if (
    event.senderType === ConversationSenderType.Visitor &&
    event.card.type === 'unfurl' &&
    event.card.createdBy === 'unfurl'
  )
    return (
      <XIcon
        onClick={() => mutate({ variables: { id: event._id } })}
        className={tw`h-4 w-4 absolute top-0.5 -left-6 text-neutral-300 cursor-pointer`}
      />
    )

  return null
}

export function UnfUrlCard({ event }: Props) {
  const tw = useTw()
  return (
    <div className={tw`relative pl-3 border-l max-w-xs`}>
      <RemoveCard event={event} />
      {event.card.appIcon || event.card.appTitle ? (
        <div className={tw`flex items-start space-x-2 mb-2`}>
          {event.card.appIcon ? (
            <img
              className={tw`h-4 w-4 rounded`}
              src={event.card.appIcon}
              alt={event.card.appTitle}
            />
          ) : null}
          {event.card.appTitle ? (
            <h3 className={tw`-mt-0.5 text-neutral-400 text-sm font-bold`}>
              {event.card.appTitle}
            </h3>
          ) : null}
        </div>
      ) : null}
      <a
        target="_blank"
        href={event.card.link}
        rel="noreferrer noopener"
        className={tw`text-foreground text-sm font-bold`}
      >
        {event.card.image ? (
          <img
            src={event.card.image}
            alt={event.card.appTitle}
            className={tw`rounded max-h-40 w-full object-contain object-top`}
          />
        ) : null}
        <div className={tw`mt-1`}>
          <h1>{event.card.title}</h1>
          {event.card.description ? (
            <p
              title={event.card.description}
              className={tw`text-neutral-350 text-sm max-h-28 overflow-hidden line-clamp-3`}
            >
              {event.card.description}
            </p>
          ) : null}
        </div>
      </a>
    </div>
  )
}
